var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.367 17L9.997.636 19.628 17H.367zm9.63-1.882c.374 0 .694-.133.96-.398.269-.27.404-.592.404-.966s-.135-.693-.405-.958a1.306 1.306 0 00-.959-.398 1.33 1.33 0 00-.966.398 1.307 1.307 0 00-.397.958c0 .374.132.696.397.966.27.265.592.398.966.398zm-.994-4.24h1.989l.113-4.787H8.89l.114 4.787z",
    fill: "#203B52"
  })));
}
export default __webpack_public_path__ + "static/media/warningTriangle.76fc0c5a.svg";
export { SvgWarningTriangle as ReactComponent };